import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IWorkOrder } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getWorkOrderUUID = createUUID();
const createWorkOrderUUID = createUUID();

export const useWorkOrder = (id?: string | null) => {
  const stateManager = useComponentState();

  const [workOrder, setWorkOrder] = useState<IWorkOrder | null>(null);

  const getWorkOrder = () => {
    stateManager.abort(getWorkOrderUUID);
    return stateManager.run(async () => {
      if (!id) {
        return null;
      }

      const response = await taskService.workOrders.getById({ id });

      if (response.status === HTTP_STATUSES.OK) {
        setWorkOrder(response.data);
      }

      return response;
    }, getWorkOrderUUID);
  };

  const createWorkOrder = (data: {
    homeId: string;
    workOrderTemplateId: string;
    workOrderDuration?: number;
    workOrderName?: string;
    workOrderAbbreviation?: string;
    softDueDate?: string;
    hardDueDate?: string;
    orderId?: string;
    notes?: string;
  }) => {
    stateManager.abort(createWorkOrderUUID);
    return stateManager.run(
      () =>
        taskService.workOrders.create({
          data,
          toastMessageConfig: {
            success: {
              text: "Work order created successfully",
            },
          },
        }),
      createWorkOrderUUID
    );
  };

  return {
    workOrder,
    getWorkOrder,
    createWorkOrder,
    isLoading: stateManager.isBusy(),
  };
};
